import Util from "@/helper/Utility"
import ConfigManager from "@/config/ConfigManager.js";
// plugin
import axios from 'axios';  

/**
 * @method sendErrorLogMongoDb
 * @method sendSuccessLogMongoDb
 * @method sendErrorLogMongoDbDefaultJson
 */

export default {

    /** 
         * @param {String} blob_path 
         * @param {String} appname appname for each app
         * @param {String} theme theme for each app 
         * @param {String} tagName  
         */
    sendErrorLogMongoDbDefaultJson: function (blob_path, appname, theme, tagName) {
        try{
            //let response = err.response;

            let request_api = blob_path;
            let error_id = "";
            let error_code = "";
            let response_api = "";
            let header_api = "";
            let error_api = "";
            let method_api = "";
            let error_client = "";

            let tag = tagName;
            let os = Util.getOSName();
            let browser = Util.getBrowserVersion(); 
            let note = "&theme=" + theme;
            let data = {
                appid: "",
                appname: appname,
                error_id: error_id,
                error_code: error_code,
                error_api: error_api,
                request_api: request_api,
                response_api: response_api,
                method_api: method_api,
                header_api: header_api,
                error_client: error_client,
                note: note,
                tag: tag,
                user_agent: navigator.userAgent,
                os: os,
                browser: browser,
                weburl: window.location.href,
                created_date: new Date(),
            }
            
            const strUrl = ConfigManager.getLogMongoDbApiUrl();  
            var header = { 
            };  
            axios({
                method: "post",
                url: strUrl,
                data: data,
                headers: header,
            })   

        }catch(e){
            console.log(e.message);
        }
    },
    /** 
         * @param {Object} err error from connect bzbs api
         * @param {String} params params send to api
         * @param {String} appname appname for each app
         * @param {String} theme theme for each app 
         */
    sendErrorLogMongoDb: function (err, params, appname, theme, tagName) {
        // disabled
        if (tagName == "default.json") {
            return;
        }
        try{ 
            let response = err.response;
        
            let request_api = params ? Util.toJsonStr(params) : "";
            let error_id = response.data && response.data.error && response.data.error.id ? response.data.error.id : "";
            let error_code = response.data && response.data.error && response.data.error.code ? response.data.error.code : "";
            let response_api = response.data ? Util.toJsonStr(response.data) : "";
            let header_api = err.config && err.config.headers ? Util.toJsonStr(err.config.headers) : "";
            let error_api = err.config && err.config.url ? err.config.url : "";
            let method_api = err.config && err.config.method ? err.config.method : "";
            let error_client = "";

            let tag = "weblandingvue";
            let os = Util.getOSName();
            let browser = Util.getBrowserVersion();
            let note = "&theme=" + theme;
            let data = {
                appid: "",
                appname: appname,
                error_id: error_id,
                error_code: error_code,
                error_api: error_api,
                request_api: request_api,
                response_api: response_api,
                method_api: method_api,
                header_api: header_api,
                error_client: error_client,
                note: note,
                tag: tag,
                user_agent: navigator.userAgent,
                os: os,
                browser: browser,
                weburl: window.location.href,
                created_date: new Date(),
            }
    
            const strUrl = ConfigManager.getLogMongoDbApiUrl();  
            var header = { 
            };  
            axios({
                method: "post",
                url: strUrl,
                data: data,
                headers: header,
            })    
        }catch(e){
            console.log(e.message);
        }
    },
    
    /** 
     * @param {String} appname appname for each app
     * @param {String} theme theme for each app
     * @param {String} request_api param to send
     * @param {Object} res response success object from connect bzbs api
     */
    sendSuccessLogMongoDb: function (appname, theme, request_api, res, tagName)  {   
        // disabled
        if (tagName == "default.json") {
            return;
        }
        try{ 
            let error_data = ""; // no error 
            let url = res.config.url;
            let method_api = res.config.method;
            let header_api =  Util.toJsonStr(res.config.headers);
            let response_api = res.data;
    
            let error_code = "";
            let error_id = "";
            let os = Util.getOSName();
            let browser = Util.getBrowserVersion();
            let note = "&theme=" + theme;
            error_data = error_data || ""; 
            let error_api = url;  // url ที่จะ log
            response_api = response_api || ""; // response data
        
            if (error_data) {
                if (error_data.error) {
                    error_code = error_data.error.code;
                    error_id = error_data.error.id;
                }
                response_api = JSON.stringify(error_data);
            }
            else if (response_api) {
                response_api = JSON.stringify(response_api);
            }

            if (request_api) { 
                request_api = JSON.stringify(request_api);
            }

            var data = {
                appid: "",
                tag: "weblandingvue",
                appname: appname,
                request_api: request_api,
                method_api: method_api,
                header_api: header_api,
                note: note,
                user_agent: window.navigator.userAgent,
                weburl: window.location.href, 
                response_api: response_api,
                error_api: error_api,
                error_id: error_id, 
                error_code: error_code,
                os: os,
                browser: browser, 
                created_date: new Date(),
            };

            const strUrl = ConfigManager.getLogMongoDbApiUrl();   
            var header = { 
            };  
            axios({
                method: "post",
                url: strUrl,
                data: data,
                headers: header,
            })   
        }catch(e){
            console.log(e.message);
        }
    } 
}